<mwe-basic-card>
  <div class="text-center">
    <mwe-product-icon [category]="product().category" size="md" [textNodeType]="textNodeType()" />
    <p class="text--legal mb-0 mt-1">
      {{ product().category | correlatedCompanyReference }}
    </p>
  </div>
</mwe-basic-card>
